// extracted by mini-css-extract-plugin
module.exports = {"send-layout":"Send_send-layout__1YuWc","picker":"Send_picker__2jGAx"};